import React from "react";

function AdditionalDetails({ formData, handleChange }) {
  console.log("formDataformData",formData)
  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
      <legend className="text-lg font-semibold px-2">Additional Details</legend>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 font-medium">Area (sq. ft)</label>
          <input
            type="number"
            name="area"
            value={formData?.projectDetails?.area || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="Enter area in sq. ft"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Price per Sq. Ft (₹)</label>
          <input
            type="number"
            name="pricePerSqft"
            value={formData?.projectDetails?.pricePerSqft || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="Enter price per sq. ft"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Total Units</label>
          <input
            type="number"
            name="totalUnits"
            value={formData?.projectDetails?.totalUnits || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="Enter total units"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Total Towers</label>
          <input
            type="number"
            name="totalTowers"
            value={formData?.projectDetails?.totalTowers || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="Enter total towers"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Project Size (Sq. m)</label>
          <input
            type="number"
            name="projectSize"
            value={formData?.projectDetails?.projectSize || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="Enter project size"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Launch Date</label>
          <input
            type="date"
            name="launchDate"
            value={formData?.projectDetails?.launchDate || ""}
            onChange={handleChange}
            data-section="projectDetails"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium">Status</label>
          <select
            name="status"
            value={formData?.projectDetails?.status || ""}
            onChange={handleChange}
            data-section="projectDetails"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          >
            <option value="">Select Status</option>
            <option value="Under Construction">Under Construction</option>
            <option value="Ready to Move">Ready to Move</option>
          </select>
        </div>
        <div>
          <label className="block text-gray-700 font-medium">BHK Options</label>
          <input
            type="text"
            name="bhkOptions"
            value={formData?.projectDetails?.bhkOptions || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="e.g. 1 BHK, 2 BHK, 3 BHK"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
            required
          />
        </div>
        <div className="col-span-2">
          <label className="block text-gray-700 font-medium">RERA Number</label>
          <input
            type="text"
            name="reraNumber"
            value={formData?.projectDetails?.reraNumber || ""}
            onChange={handleChange}
            data-section="projectDetails"
            placeholder="Enter RERA number"
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
        </div>
      </div>
    </fieldset>
  );
}

export default AdditionalDetails;
